import {CgPlayListAdd} from 'react-icons/cg'
import {SiYoutubegaming} from 'react-icons/si'
import {IoHomeSharp} from 'react-icons/io5'
import {HiFire} from 'react-icons/hi'

import ModeContext from '../../context/ModeContext'

import {
  SideContianer,
  SideCard,
  Li,
  List,
  Bottom,
  SidebarP,
  ContactIcons,
  ContactIcon,
  Button,
} from './styledComponents'

import './index.css'

const SideBar = () => (
  <ModeContext.Consumer>
    {value => {
      const {isDarkMode, path, changePath} = value

      const sidebarListItem = isDarkMode ? 'white-list' : 'dark-list'
      const HomeCurrent = path === 'Home' ? 'hightLight' : ''
      const TrendingCurrent = path === 'Trending' ? 'hightLight' : ''
      const GamingCurrent = path === 'Gaming' ? 'hightLight' : ''
      const SavedCurrent = path === 'Saved' ? 'hightLight' : ''

      const onClickTrending = () => {
        changePath('Trending')
      }
      const onClickHome = () => {
        changePath('Home')
      }
      const onClickGaming = () => {
        changePath('Gaming')
      }
      const onClickSaved = () => {
        changePath('Saved')
      }

      return (
        <SideContianer dark={isDarkMode}>
          <SideCard dark={isDarkMode}>
            <ul className="sidebar-options">
              <Li
                dark={isDarkMode}
                active={HomeCurrent}
                onClick={onClickHome}
                to="/"
                className={`link ${sidebarListItem}`}
              >
                <li key="1" className={HomeCurrent}>
                  {' '}
                  <IoHomeSharp /> <List dark={isDarkMode}>Home</List>
                </li>
              </Li>
              <Li
                to="/trending"
                dark={isDarkMode}
                active={TrendingCurrent}
                onClick={onClickTrending}
                className={`link ${sidebarListItem}`}
              >
                <li key="2" className={TrendingCurrent}>
                  <HiFire />
                  <List dark={isDarkMode}>Trending</List>
                </li>
              </Li>
              <Li
                dark={isDarkMode}
                active={GamingCurrent}
                onClick={onClickGaming}
                to="/gaming"
                className={`link ${sidebarListItem}`}
              >
                <li key="3" className={GamingCurrent}>
                  {' '}
                  <SiYoutubegaming /> <List dark={isDarkMode}>Gaming</List>
                </li>
              </Li>
              <Li
                dark={isDarkMode}
                active={SavedCurrent}
                onClick={onClickSaved}
                to="/saved-videos"
                className={`link ${sidebarListItem}`}
              >
                <li key="4" className={SavedCurrent}>
                  {' '}
                  <CgPlayListAdd /> <List dark={isDarkMode}>Saved Videos</List>
                </li>
              </Li>
            </ul>
            <Bottom>
              <SidebarP dark={isDarkMode} contact>
                CONTACT US
              </SidebarP>
              <ContactIcons>
                <ul className="ul">
                  <li key="1">
                    <Button data-testid="theme">
                      <ContactIcon
                        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                        alt="facebook logo"
                      />
                    </Button>
                  </li>
                  <li key="2">
                    <Button data-testid="theme">
                      <ContactIcon
                        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                        alt="twitter logo"
                      />
                    </Button>
                  </li>
                  <li key="3">
                    <Button data-testid="theme">
                      <ContactIcon
                        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                        alt="linked in logo"
                      />
                    </Button>
                  </li>
                </ul>
              </ContactIcons>
              <SidebarP dark={isDarkMode}>
                Enjoy! Now to see your channels and recommendations!
              </SidebarP>
            </Bottom>
          </SideCard>
        </SideContianer>
      )
    }}
  </ModeContext.Consumer>
)

export default SideBar

// import {Link} from 'react-router-dom'
// import {SiYoutubegaming} from 'react-icons/si'
// import {IoHomeSharp} from 'react-icons/io5'

// import ModeContext from '../../context/ModeContext'

// import {
//   SideContianer,
//   SideCard,
//   Top,
//   Ul,
//   Li,
//   List,
//   Bottom,
//   SidebarP,
//   ContactIcons,
//   ContactIcon,
//   Button,
// } from './styledComponents'

// import './index.css'

// const SideBar = () => (
//   <ModeContext.Consumer>
//     {value => {
//       const {isDarkMode, path, changePath} = value
//       const sidebarListItem = isDarkMode ? 'white-list' : 'dark-list'
//       const HomeCurrent = path === 'Home' ? 'hightLight' : ''
//       const TrendingCurrent = path === 'Trending' ? 'hightLight' : ''
//       const GamingCurrent = path === 'Gaming' ? 'hightLight' : ''
//       const SavedCurrent = path === 'Saved' ? 'hightLight' : ''

//       const onClickHome = () => {
//         changePath('Home')
//       }
//       const onClickTrending = () => {
//         changePath('Trending')
//       }
//       const onClickGaming = () => {
//         changePath('Gaming')
//       }
//       const onClickSaved = () => {
//         changePath('Saved')
//       }

//       return (
//         <>
//           <SideContianer dark={isDarkMode}>
//             <SideCard dark={isDarkMode}>
//               <Top>
//                 <Ul className="sidebar-options">
//                   <Link to="/" className={`${sidebarListItem} ${HomeCurrent}`}>
//                     <li onClick={onClickHome}>
//                       <IoHomeSharp />
//                       <List dark={isDarkMode}>Home</List>
//                     </li>
//                   </Link>
//                   <Link
//                     to="/trending"
//                     className={`${sidebarListItem} ${TrendingCurrent}`}
//                   >
//                     <li onClick={onClickTrending}>
//                       <HiFire />
//                       <List dark={isDarkMode}>Trending</List>
//                     </li>
//                   </Link>
//                   <Link
//                     to="/gaming"
//                     className={`${sidebarListItem} ${GamingCurrent}`}
//                   >
//                     <li onClick={onClickGaming}>
//                       <SiYoutubegaming />
//                       <List dark={isDarkMode}>Gaming</List>
//                     </li>
//                   </Link>
//                   <Link
//                     to="/saved-videos"
//                     className={`${sidebarListItem} ${SavedCurrent} `}
//                   >
//                     <li onClick={onClickSaved}>
//                       <CgPlayListAdd />
//                       <List dark={isDarkMode}>Saved Videos</List>
//                     </li>
//                   </Link>
//                 </Ul>
//               </Top>
// <Bottom>
//   <SidebarP dark={isDarkMode} contact>
//     CONTACT US
//   </SidebarP>
//   <ContactIcons>
//     <Button data-testid="theme">
//       <ContactIcon
//         src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
//         alt="facebook logo"
//       />
//     </Button>
//     <Button data-testid="theme">
//       <ContactIcon
//         src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
//         alt="twitter logo"
//       />
//     </Button>
//     <Button data-testid="theme">
//       <ContactIcon
//         src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
//         alt="linked in logo"
//       />
//     </Button>
//   </ContactIcons>
//   <SidebarP dark={isDarkMode}>
//     Enjoy! Now to see your channels and recommendations!
//   </SidebarP>
// </Bottom>
//             </SideCard>
//           </SideContianer>
//         </>
//       )
//     }}
//   </ModeContext.Consumer>
// )
// export default SideBar
